import { __rest } from "tslib";
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import './Card.less';
const Card = (_a, ref) => {
    var { className, noPadding = false } = _a, props = __rest(_a, ["className", "noPadding"]);
    return React.createElement("div", Object.assign({ className: clsx(className, noPadding && 'kal-no-padding', 'kal-card'), ref: ref }, props));
};
export default forwardRef(Card);
//# sourceMappingURL=Card.js.map